import { ReactElement } from 'react'
import Text from 'components/shared/Text'
import { PromotionBadgeBox, PromotionBadgeBoxProps } from './styles'

interface PromotionBadgeProps extends PromotionBadgeBoxProps {
    element: ReactElement
}

export const PromotionBadge = ({ element, ...rest }: PromotionBadgeProps) => (
    <PromotionBadgeBox pt={4} pb={4} pl={8} pr={8} {...rest}>
        <Text variant="bodyExtraSmall" color="grayscale_0">
            {element}
        </Text>
    </PromotionBadgeBox>
)
